import { TPlot } from "stencil-library";
import { CORE_API, APP_SERVER_API } from "../constants";
import { getData, postData } from "./common.service";

class PlotSerivce {
  private static readonly baseUrl = "/plots";

  static getDeviceType = (plotId: string): Promise<TPlot> => {
    const filterQuery = {
      fields: {
        plotId: true,
      },
      include: ["device"],
    };

    const url =
      this.baseUrl + `/${plotId}?filter=${JSON.stringify(filterQuery)}`;
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static getDiseasePrediction = (plotId: string): Promise<Array<TDiseasePestPrediction>> => {
    const url = this.baseUrl + `/${plotId}/disease-list`;

    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static getPestPrediction = (plotId: string): Promise<Array<TDiseasePestPrediction>> => {
    const url = this.baseUrl + `/${plotId}/pest-list`;

    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  };

  static async getPlotList(farmUserId: string): Promise<Array<TActivity>> {
    const filter = JSON.stringify({
      include: ["cropsSown"],
      where: { farmUserId: farmUserId }
    });

    const url = `${this.baseUrl}?filter=${encodeURIComponent(filter)}`;

    return getData(url, {
      basePath: APP_SERVER_API,
      sendTokenInUrl: true,
    });
  }

  static async getRecentCropSownId(plotId: string): Promise<Array<TCropSownId>> {
    const filterQuery = JSON.stringify({
      "limit": 1,
      "order": "sowingDate DESC",
      "where": {
        "plotId": plotId
      },
      "fields": {
        "cropSownId": true
      }
    });

    const url = `/crop-sowns?filter=${encodeURIComponent(filterQuery)}`;

    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  }

  static async continueCropSeason(cropSownId: string): Promise<{ message: string }> {
    const url = `/crop-sowns/${cropSownId}`;
    const payload = {
      isCropEnded: false,
      cropEndDate: undefined
    };

    return postData(url, {
      usePatchMethod: true,
      basePath: CORE_API,
      sendTokenInHeader: true,
      body: payload,
    });
  }

  static async getSupportedCrop(): Promise<Array<TSupportedCrop>> {
    const url = "/crops/supported";
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  }

  static async getIrrigationHour(payload: TFormulaPayload):Promise<{result: number}>{
    const url = "/formulas/617c1d8465f1de91090cc5e5/evaluate";
    return postData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
      body: payload
    });
  }

  static async patchPlot(payload:TPlotPayload, plotId:string){
    const url = this.baseUrl+`/${plotId}`;
    return postData(url, {
      usePatchMethod: true,
      basePath: CORE_API,
      sendTokenInHeader: true,
      body: payload,
    });
  }
          

  static async getIrrigationHourBySprinkler(payload: TFormulaPayload):Promise<{result: number}> {
    const url = "/formulas/65796b4344f8ec6c8000b73a/evaluate";
    return postData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
      body: payload,
    });
  }
  static async getPlotData(plotId: string): Promise<TPlot>{
    const url = this.baseUrl+`/${plotId}`;
    return getData(url, {
      basePath: CORE_API,
      sendTokenInHeader: true,
    });
  }
}

export default PlotSerivce;

export type TDiseasePestPrediction = {
  diseaseId?: string;
  pestId?: string;
  isApplicable: boolean;
  oldDiseaseId?: string;
  oldPestId?: string;
  value?: number;
  minValue?: number;
  maxValue?: number;
  description?: string;
  labels?: Array<TLabel>;
  displayName: string;
};

type TLabel = {
  min: number;
  max: number;
  name: string;
  labelColor: string;
  activeBarColor: string;
};

type TCropSown = {
  activeStage: string;
  created_date: string;
  cropId: string;
  cropSownId: string;
  cropStageIds: string[];
  expectedHarvestEnd: string;
  expectedHarvestStart: string;
  isCropEnded: boolean;
  name: string;
  plotId: string;
  sowingDate: string;
  stageStartDate: string[];
  stageUpdated: boolean;
  varietyId: string;
};

type TLocation = {
  lat: number;
  lng: number;
};

type TActivity = {
  altitude: number;
  area: number;
  created_date: string;
  cropsSown: TCropSown;
  district: string;
  farmId: string;
  farmUserId: string;
  location: TLocation;
  name: string;
  nearestPlots: [];
  place: string;
  plantationYear: string;
  plotId: string;
  regionIds: string[];
  soilTypeId: string;
  taluka: string;
};

type TCropSownId = {
  cropSownId: string
}

export type TSupportedCrop = {
  cropId: string,
  cropName: string,
  id: string,
  name: string,
  displayName: string
};

export type TFormulaPayload = {
  a: number
  b: number,
  c: number,
  d?: number,
  e?: number,
}

export type TPlotPayload = {
  rootWidth?: number,
  rootDepth: number,
  soilRetention: number,
  dripperDistance?: number,
  dripperDischarge: number,
  irrigationHours: number,
}
